"use strict";

var _defineProperty = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/defineProperty.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadOnlyWallet = void 0;
const web3_js_1 = require("@solana/web3.js");
class ReadOnlyWallet {
  constructor() {
    let publicKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : web3_js_1.PublicKey.default;
    _defineProperty(this, "publicKey", void 0);
    this.publicKey = publicKey;
  }
  signTransaction(_transaction) {
    throw new Error("Read only wallet cannot sign transaction.");
  }
  signAllTransactions(_transactions) {
    throw new Error("Read only wallet cannot sign transactions.");
  }
}
exports.ReadOnlyWallet = ReadOnlyWallet;
//# sourceMappingURL=wallet.js.map